var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, ButtonGroup } from 'reactstrap';
import cxs from 'cxs';
var styles = {
    header: cxs({
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        padding: '12px 16px',
    }),
    dateLabel: cxs({
        fontSize: '1.1rem',
        fontWeight: 500,
        color: '#333',
    }),
    navButton: cxs({
        minWidth: '40px',
    }),
    rangeButton: cxs({
        minWidth: '50px',
    }),
    refreshButton: cxs({
        marginLeft: '8px',
    }),
};
var RANGE_OPTIONS = [
    { days: 1, label: '1d' },
    { days: 2, label: '2d' },
    { days: 3, label: '3d' },
    { days: 7, label: '7d' },
];
var CalendarHeader = /** @class */ (function (_super) {
    __extends(CalendarHeader, _super);
    function CalendarHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRangeChange = function (days) {
            _this.props.store.setDaysToShow(days);
        };
        _this.handlePrev = function () {
            _this.props.store.prevPeriod();
        };
        _this.handleNext = function () {
            _this.props.store.nextPeriod();
        };
        _this.handleToday = function () {
            _this.props.store.goToToday();
        };
        _this.handleRefresh = function () {
            _this.props.store.fetchSlots();
        };
        return _this;
    }
    CalendarHeader.prototype.render = function () {
        var _this = this;
        var store = this.props.store;
        return (React.createElement(Row, { className: styles.header },
            React.createElement(Col, { xs: "auto", className: "d-flex align-items-center" },
                React.createElement(ButtonGroup, { size: "sm", className: "mr-2" },
                    React.createElement(Button, { color: "secondary", outline: true, onClick: this.handlePrev, className: styles.navButton, title: "Anterior" }, '<'),
                    React.createElement(Button, { color: "secondary", outline: true, onClick: this.handleNext, className: styles.navButton, title: "Siguiente" }, '>')),
                React.createElement(Button, { color: "primary", size: "sm", outline: true, onClick: this.handleToday, className: "mr-3" }, "Hoy"),
                React.createElement(ButtonGroup, { size: "sm" }, RANGE_OPTIONS.map(function (option) { return (React.createElement(Button, { key: option.days, color: store.daysToShow === option.days ? 'primary' : 'secondary', outline: store.daysToShow !== option.days, onClick: function () { return _this.handleRangeChange(option.days); }, className: styles.rangeButton }, option.label)); }))),
            React.createElement(Col, { className: "d-flex align-items-center justify-content-center" },
                React.createElement("span", { className: styles.dateLabel }, store.dateRangeLabel)),
            React.createElement(Col, { xs: "auto", className: "d-flex align-items-center" },
                React.createElement(Button, { color: "secondary", size: "sm", outline: true, onClick: this.handleRefresh, title: "Refrescar" }, "\u21BB Refrescar"))));
    };
    CalendarHeader = __decorate([
        observer
    ], CalendarHeader);
    return CalendarHeader;
}(Component));
export default CalendarHeader;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/CalendarHeader.tsx
// module id = 1608
// module chunks = 0